
import "./About.css";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";
const About = () => {
    const checkoutUrl = "https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1";
    useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  return (
    <div className="about-wrap">

      {/* HERO */}
      <div className="about-hero">
        <div className="about-kicker">
          ABOUT • <b>FORGEYOURPEAK</b>
        </div>

        <h1>
          Train the System.
          <br />
          Not Just the Skill.
        </h1>

        <p className="about-sub">
          ForgeYourPeak is a performance platform that builds the visual and cognitive systems behind elite execution —
          so athletes see earlier, decide faster, and perform more consistently under pressure.
        </p>

        <div className="about-ctaRow">
          <Link className="about-btn primary" to="/webinar">
            🎥 Join Free Webinar
          </Link>
          <button className="about-btn">
            Book a Free Discovery Call
          </button>
        </div>
      </div>

      {/* MISSION */}
      <div className="about-section">
        <div className="about-pad">
          <h2>Our Mission</h2>
          <p className="about-muted">
            To help athletes reach their genetic potential by improving the brain-body performance loop:
            <b> Vision → Processing → Decision → Movement → Recovery</b>.
          </p>

          <div className="about-split">
            <div className="about-card">
              <h3>What We Believe</h3>
              <p>
                Performance is not just strength or technique. It’s the quality of your <b>input</b>,
                your <b>processing</b>, and your <b>output</b>.
              </p>
            </div>

            <div className="about-card">
              <h3>How We Train</h3>
              <p>
                Structured neuro-performance training built around
                <b> Vision, Hand–Eye, Memory, Anticipation, and Sleep</b>.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* FOUNDER */}
      <div className="about-section">
        <div className="about-pad">
          <h2>Founder</h2>
          <p className="about-muted">A short, honest introduction.</p>

          <div className="about-founder">
            <div className="about-avatar"> <img
            src="/hero/vevek-hero.jpeg"
            alt="Vevek Founder"
            className="about-avatar"
          /></div>

            <div>
              <b>Vevek S. • Founder, ForgeYourPeak</b>
              <p className="about-muted founder-text">
                Health & Wellness coach specializing in vision and cognitive training.
              </p>

              <div className="about-badges">
                <div className="about-badge">Vision training</div>
                <div className="about-badge">Athlete systems</div>
                <div className="about-badge">Measurement-driven</div>
                <div className="about-badge">Chennai, India</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* HOW FORGEYOURPEAK STARTED */}
<div className="about-section">
  <div className="about-pad">

    <h2>How ForgeYourPeak Started</h2>
    <p className="about-muted">
      A simple timeline that builds trust and context.
    </p>

    <div className="timeline">

      <div className="timeline-item">
        <div className="timeline-phase">Phase 1</div>
        <div className="timeline-text">
          Built the core belief: athletes don’t fail for lack of effort —
          they fail when input and processing break under speed.
        </div>
      </div>

      <div className="timeline-item">
        <div className="timeline-phase">Phase 2</div>
        <div className="timeline-text">
          Developed a structured training stack around vision, cognition,
          and coordination — tested in real athlete environments.
        </div>
      </div>

      <div className="timeline-item">
        <div className="timeline-phase">Phase 3</div>
        <div className="timeline-text">
          Created Bootcamp (L0) as the entry point and Ignite (L1)
          as the deeper performance pathway.
        </div>
      </div>

    </div>

  </div>
</div>

      {/* VALUES */}
      <div className="about-section">
        <div className="about-pad">
          <h2>What We Stand For</h2>
          <p className="about-muted">Values that guide our programs.</p>

          <div className="about-values">
            <div className="about-v">
              <b>Clarity over hype</b>
              <p>Simple measurable inputs beat noise.</p>
            </div>

            <div className="about-v">
              <b>Systems over shortcuts</b>
              <p>Repeatable frameworks win.</p>
            </div>

            <div className="about-v">
              <b>Transfer over vanity</b>
              <p>Training must show up in matches.</p>
            </div>

            <div className="about-v">
              <b>Consistency over intensity</b>
              <p>Sustained improvements matter.</p>
            </div>

            <div className="about-v">
              <b>Recovery is training</b>
              <p>Sleep protects performance.</p>
            </div>

            <div className="about-v">
              <b>Athlete-first</b>
              <p>Built for real schedules & stress.</p>
            </div>
          </div>
        </div>
      </div>

      {/* FINAL CTA */}
      <div className="about-section final">
        <div className="about-pad">
          <h2>Ready to Start?</h2>
          <p className="about-muted">
            Begin with Bootcamp. Build the system.
          </p>

          <div className="about-ctaRow">
            <Link className="about-btn primary" to="/webinar">
                🎥 Join Free Webinar
              </Link>
            <Link to="/ignite#waitlist" className="about-btn">
              Join Ignite Waitlist
            </Link>
          </div>

         
        </div>
      </div>

      <div className="about-footer">
        © ForgeYourPeak • About
      </div>
    </div>
  );
};

export default About;